import { login } from './login'
import { logout } from './logout'

export const Login = {
  login,
  logout
}
